'use client';
import type { ReactElement } from 'react';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { Cbutton } from '@/components/ui/Cbutton';
import { ButtonPreset } from '@/constants/componentPresets';
import { FontWeight } from '@/theme';
interface CfooterStateActionButtonProps {
    dataName: string;
    label: string;
    isActive: boolean;
    onClick: () => void;
}
interface CfooterLinkActionButtonProps {
    href: string;
    dataName: string;
    wrapperName: string;
    label: string;
    onClick: () => void;
}
export function CfooterStateActionButton({ dataName, label, isActive, onClick, }: CfooterStateActionButtonProps): ReactElement {
    return (
      <motion.div animate={{ opacity: isActive ? 0.4 : 0.7 }} transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }} style={{ display: 'flex' }}>
        <Cbutton preset={ButtonPreset.Ghost} label={label} textWeight={FontWeight.Light} onClick={onClick} disabled={isActive}/>
      </motion.div>
    );
}
export function CfooterLinkActionButton({ href, dataName, wrapperName, label, onClick, }: CfooterLinkActionButtonProps): ReactElement {
    return (
      <Link href={href} onClick={onClick} style={{ textDecoration: 'none' }}>
        <motion.div animate={{ opacity: 0.7 }} transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }} style={{ display: 'flex' }}>
          <Cbutton preset={ButtonPreset.Ghost} label={label} textWeight={FontWeight.Light}/>
        </motion.div>
      </Link>
    );
}
